import React, { useState } from 'react';
import ClickAwayListener from 'react-click-away-listener';
import {
  ChevronDownIcon as ExpandIcon,
  ChevronUpIcon as ContractIcon,
} from '@heroicons/react/solid';

import { LoadingIndicator } from 'components/LoadingIndicator';
import { useChain } from 'contexts';

type Props = {
  label: string;
  value: string;
};

const LabelValueCard: React.FC<Props> = ({ label, value, children }) => {
  const { styleSlug } = useChain();
  const [isExpanded, setIsExpanded] = useState(false);

  const isExpandable = !!children;
  const labelColor = isExpanded
    ? `text-${styleSlug}-light`
    : `text-${styleSlug}-primary dark:text-${styleSlug}-light`;
  const textColor = isExpanded ? 'text-white' : 'text-gray-444 dark:text-white';
  const containerClassNames = [
    'flex justify-between align-center px-4 py-3 overflow-hidden text-lg',
  ];
  if (isExpandable) {
    containerClassNames.push('cursor-pointer');
  }
  if (isExpanded) {
    containerClassNames.push(
      `rounded-t-10 bg-${styleSlug}-dark bg-gradient-to-b dark:from-${styleSlug}-dark dark:to-gray-111 dark:box-shadow-inset`
    );
  } else {
    containerClassNames.push(`rounded-10 bg-white dark:bg-gray-111`);
  }

  return (
    <ClickAwayListener onClickAway={() => setIsExpanded(false)}>
      <div className="relative">
        <div
          className={`${
            isExpanded ? `rounded-t-xl bg-${styleSlug}-dark` : `rounded-xl bg-${styleSlug}-primary`
          } bg-gradient-to-l dark:from-${styleSlug}-light dark:to-${styleSlug}-primary`}
          style={{ padding: isExpanded ? '2px 2px 0 2px' : 2 }}
        >
          <div
            className={containerClassNames.join(' ')}
            onClick={() => isExpandable && setIsExpanded((currentIsExpanded) => !currentIsExpanded)}
          >
            <span className={`uppercase ${labelColor}`}>{label}</span>
            <span className={textColor}>
              {value !== '-' ? value : <LoadingIndicator />}{' '}
              {isExpandable &&
                (isExpanded ? (
                  <ContractIcon className={`inline w-5 h-5 ${labelColor}`} />
                ) : (
                  <ExpandIcon className={`inline w-5 h-5 ${labelColor}`} />
                ))}
            </span>
          </div>
        </div>
        {isExpanded && (
          <div
            className={`absolute w-full z-50 rounded-b-xl bg-${styleSlug}-dark bg-gradient-to-l dark:from-${styleSlug}-light dark:to-${styleSlug}-primary`}
            style={{ padding: '0 2px 4px 2px' }}
          >
            {children}
          </div>
        )}
      </div>
    </ClickAwayListener>
  );
};

export default LabelValueCard;
